/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Cancelled_LedeInputs */

const en_mcp_connect_cancelled_lede = /** @type {(inputs: Mcp_Connect_Cancelled_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} wasn’t given access to your Listening account.`)
};

const es_mcp_connect_cancelled_lede = /** @type {(inputs: Mcp_Connect_Cancelled_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} no recibió acceso a tu cuenta de Listening.`)
};

/**
* | output |
* | --- |
* | "{app} wasn’t given access to your Listening account." |
*
* @param {Mcp_Connect_Cancelled_LedeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_cancelled_lede = /** @type {((inputs: Mcp_Connect_Cancelled_LedeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Cancelled_LedeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_cancelled_lede(inputs)
	return en_mcp_connect_cancelled_lede(inputs)
});